import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'
import { getMeasurementUnit } from 'selectors/user/session'
import { MeasurementUnit } from 'types/User/Session'
import { getSelectedFacetsSizeMinMax } from 'selectors/facets/sizeFacet'
import { getHrefFunction } from './helper'

const mapStateToProps = createStructuredSelector({
  getHref: getHrefFunction,
  measurementUnit: getMeasurementUnit,
  sizeMinMax: getSelectedFacetsSizeMinMax,
})

export type SizeFacetConnectorProps = {
  getHref: (filterParam: Record<string, any>) => string
  measurementUnit: MeasurementUnit
  sizeMinMax: Record<string, any>
}

export default connect(mapStateToProps)
